import { render, staticRenderFns } from "./NsMinimalHeaderMiniCart.vue?vue&type=template&id=6fdba104&scoped=true&"
import script from "./NsMinimalHeaderMiniCart.vue?vue&type=script&lang=js&"
export * from "./NsMinimalHeaderMiniCart.vue?vue&type=script&lang=js&"
import style0 from "./NsMinimalHeaderMiniCart.vue?vue&type=style&index=0&id=6fdba104&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fdba104",
  null
  
)

export default component.exports